export default "__VITE_ASSET__561a1e39__"